module.exports = __webpack_public_path__ + "1c2f54f78da5e136c3b3fd2306ada6c8.svg";